/** @description Возвращает универсальные координаты для тач нажатия или клика
 * @param e {TMouseOrTouchEvent} объект события мыши или тач нажатия
 * @return {{ x: number, y: number }}
 */

import { isTouchEvent } from './isTouchEvent';
export var getUniversalPosition = function getUniversalPosition(e) {
  var event = isTouchEvent(e) && e.changedTouches[0] || e;
  return {
    x: event.clientX || 0,
    y: event.clientY || 0
  };
};